import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.nrich.divider');
import { OnInit, ElementRef, Output, EventEmitter } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-nrich-divider',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.nrich.divider/view.scss */
:host {
  display: block;
  height: 100%;
  flex-shrink: 0;
}`],
})
export class PortalNrichDividerComponent implements OnInit {
    @Output() resize = new EventEmitter<number>();

    private isDragging: boolean = false;
    private startX: number = 0;

    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private el: ElementRef) { }

    public async ngOnInit() {
        await this.service.init();
    }

    public onMouseDown(event: MouseEvent) {
        event.preventDefault();
        this.isDragging = true;
        this.startX = event.clientX;
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';

        const onMouseMove = (e: MouseEvent) => {
            if (!this.isDragging) return;
            const delta = e.clientX - this.startX;
            this.startX = e.clientX;
            this.resize.emit(delta);
        };

        const onMouseUp = () => {
            this.isDragging = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        };

        document.addEventListener('mousemove', onMouseMove);
        document.addEventListener('mouseup', onMouseUp);
    }
}

export default PortalNrichDividerComponent;